module.exports = __webpack_public_path__ + "static/img/avatar_ys.a449af05.png";